import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';

import { InputTextSize } from '@design-system/components/molecules/input-text/entities/input-text.types';
import { SearchType } from '@search-bar/entities/search-type';

@Component({
  selector: 'app-search-input-bar',
  templateUrl: './search-input-bar.component.html',
  styleUrls: [],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class SearchInputBarComponent {

  @Input() id: string = '';
  @Input() icon: string;
  @Input() label: string;
  @Input() value: string;
  @Input() placeholder: string;
  @Input() disabled: boolean = false;
  @Input() readonly: boolean = true;
  @Input() isHome: boolean;
  @Input() searchType: SearchType;
  @Input() isMobile: boolean;
  @Input() isPackageHotelStep: boolean;

  @Output() inputFocus: EventEmitter<void> = new EventEmitter<void>();

  constructor() { }

  get inputSize(): InputTextSize {
    return !this.isMobile && (this.isResultsPage || this.isHotelDetail) ? InputTextSize.MD : InputTextSize.RG;
  }

  get filled(): boolean {
    return !this.isMobile && !this.isResultsPage && !this.isHotelDetail;
  }

  get staticFilled(): boolean {
    return !this.isMobile && (this.isResultsPage || this.isHotelDetail);
  }

  get isPackagesHome(): boolean {
    return !this.isMobile && this.searchType === SearchType.PACKAGES_HOME;
  }

  get isResultsPage(): boolean {
    return this.searchType === SearchType.HOTELS_RESULTS || this.searchType === SearchType.PACKAGES_RESULT;
  }

  get isHotelDetail(): boolean {
    return this.searchType === SearchType.HOTELS_DETAIL;
  }

  get showInputLabel(): boolean {
    return this.isHotelDetail ? this.isMobile : this.isMobile ? true : !this.isResultsPage;
  }
}
